import randomSample from "lodash/sample";
import * as t from "io-ts";

import { defined } from "./Support";
import { propertyDescriptionCodec } from "./generator/description";

const themeOverlayCodec = t.keyof({
    none: null,
    dark: null,
    color: null,
    colorDark: null,
    pureblack: null,
    purewhite: null,
});

const policyLinkCodec = t.type({
    title: propertyDescriptionCodec,
    url: propertyDescriptionCodec,
});

export const baseThemeCodec = t.intersection([
    t.type({
        primaryAccentColor: t.string,
        showTabLabels: t.boolean,
    }),
    t.partial({
        // FIXME: Why is the theme overlay sometimes missing?
        themeOverlay: themeOverlayCodec,
        themeIsAdaptive: t.boolean,
        increaseContrast: t.boolean,
        showDesktopSideBar: t.boolean,

        // FIXME: Type properly
        signInColorTheme: t.string,
        signInBackground: t.string,
        signInBackgroundUploadFileName: t.string,
        signInLogo: t.string,
        signInLogoUploadFileName: t.string,
        signInGreetingText: t.string,
        signInDescriptionText: t.string,
        signInBackgroundOverlay: t.string,
        signInLogoSize: t.string,

        fontTheme: t.string,
        // user agreement props
        requiresAgreement: t.boolean,
        agreementText: propertyDescriptionCodec,
        policyLinks: t.readonlyArray(policyLinkCodec),
    }),
]);

export type ThemeOverlay = t.TypeOf<typeof themeOverlayCodec>;
export type BaseTheme = t.TypeOf<typeof baseThemeCodec>;

export enum Color {
    Red = "#F44336",
    "Deep Orange" = "#FF5722",
    Orange = "#FF9800",
    Green = "#4CAF50",
    Teal = "#009688",
    Cyan = "#00BCD4",
    Blue = "#2196F3",
    "Deep Purple" = "#8854d0",
    Pink = "#E91E63",
}

// BaseThemes are the values that get stored and serialized to apps.
// These are not full themes are may contain values that get mapped into a runtime theme.
const baseTheme: BaseTheme = {
    primaryAccentColor: Color.Blue as string, // MUST be a hex value style string #RRGGBB
    showTabLabels: true,
    increaseContrast: false,
    themeOverlay: "none",
    showDesktopSideBar: false,
};

export function randomTheme(themeOverlay: ThemeOverlay): BaseTheme {
    const colors = Object.keys(Color).map(k => Color[k as keyof typeof Color]);
    // let themeOverlays = Object.keys(ThemeOverlay).map(k => ThemeOverlay[k as keyof typeof ThemeOverlay]);
    // if (!getFeatureFlag("colorTheme")) {
    //     themeOverlays = themeOverlays.filter(to => to !== ThemeOverlay.Color);
    // }
    return {
        ...baseTheme,
        primaryAccentColor: defined(randomSample(colors)),
        themeOverlay,
        themeIsAdaptive: true,
    };
}

export const systemFontFamily =
    "Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, Icons16, sans-serif";
